import { Splitter as SplitterAnt } from "antd"
import type { SplitterProps } from "antd"
import { SplitterProvider } from "components/providers/Splitter.provider"
import type { ReactNode } from "react"

type TSplitterPanel = {
	children: ReactNode
	defaultSize?: string | number
	size?: string | number
	min?: number
	max?: number
	collapsible?: boolean | { start?: boolean; end?: boolean }
	resizable?: boolean
	id?: string
}

type Props = {
	layout: SplitterProps["layout"]
	panels: TSplitterPanel[]
	onResize?: SplitterProps["onResize"]
	className?: string
}

export const Splitter = ({ layout, panels, onResize, className }: Props) => {
	return (
		<SplitterProvider>
			<SplitterAnt layout={layout} onResize={onResize} className={className}>
				{panels.map((panel, index) => (
					<SplitterAnt.Panel
						key={panel.id ?? index}
						defaultSize={panel.defaultSize}
						size={panel.size}
						min={panel.min}
						max={panel.max}
						collapsible={panel.collapsible}
						resizable={panel.resizable}
					>
						{panel.children}
					</SplitterAnt.Panel>
				))}
			</SplitterAnt>
		</SplitterProvider>
	)
}
